export enum PolicyDecisionOperationTypes {
    AND = "and",
    OR = "or"
}